import { useEffect } from "react";

function setTag(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * SEO component: sets document title, meta tags (OG/Twitter), and injects JSON-LD.
 * Props: title, description, keywords, image, schemas (array of JSON-LD objects)
 */
export default function Seo({ title, description, keywords, image, schemas = [] }) {
  const schemasJson = JSON.stringify(schemas);
  useEffect(() => {
    if (title) document.title = title;
    setTag("name", "description", description);
    setTag("name", "keywords", keywords);
    setTag("property", "og:title", title);
    setTag("property", "og:description", description);
    setTag("property", "og:type", "website");
    setTag("property", "og:image", image);
    setTag("name", "twitter:card", "summary_large_image");
    setTag("name", "twitter:title", title);
    setTag("name", "twitter:description", description);
    setTag("name", "twitter:image", image);

    const added = [];
    JSON.parse(schemasJson).forEach((schema) => {
      if (!schema) return;
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo", "true");
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
      added.push(script);
    });

    return () => added.forEach((s) => s.remove());
  }, [title, description, keywords, image, schemasJson]);

  return null;
}

export const personSchema = (settings) => ({
  "@context": "https://schema.org",
  "@type": "Person",
  name: "Girish Kumar Naidu",
  jobTitle: "Social Worker and Aspirant Candidate for GBA Hoodi Ward 29",
  description:
    "Social worker, charitable trust leader, and aspirant candidate for GBA Hoodi Ward 29 under the Greater Bengaluru Authority.",
  areaServed: { "@type": "Place", name: "Hoodi Ward 29, Bengaluru, Karnataka, India" },
  affiliation: { "@type": "Organization", name: "Girish Naidu Charitable Trust" },
  address: { "@type": "PostalAddress", addressLocality: "Bengaluru", addressRegion: "Karnataka", addressCountry: "IN" },
  email: settings?.email,
  telephone: settings?.phone,
  sameAs: settings?.socialLinks ? Object.values(settings.socialLinks).filter(Boolean) : [],
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: it.url,
  })),
});
